import {
  AfterContentInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { DialogService, RejectionsService } from '../../services/standard';
import { Observable } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { tap } from 'rxjs/operators';

interface Rejection {
  url: string;
  finalRejectReason?: string;
}

@Component({
  selector: 'prism-rejections-display',
  templateUrl: './rejections-display.component.html',
  styleUrls: ['./rejections-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RejectionsDisplayComponent implements OnInit, AfterContentInit {

  jobId;
  currentIndex: number;
  loadedRejections;
  rejectedAssets$: Observable<any> = this.rejectsService.rejectedAssets$
    .pipe(
      tap(rejections => {
        if (!!rejections && !!rejections[this.jobId]) {
          this.loadedRejections = rejections[this.jobId];
        }
      })
    );
  loadingRejections$: Observable<boolean> = this.rejectsService.loadingRejections$;

  @ViewChildren('rejectText') rejectTexts: QueryList<ElementRef<HTMLTextAreaElement>>;
  @ViewChild('rejectedAssetsCarousel', {static: true}) assetListScroll: CdkVirtualScrollViewport;
  downloadingPdf = false;

  constructor(private rejectsService: RejectionsService,
              private cd: ChangeDetectorRef,
              private dialogService: DialogService) {
  }

  ngOnInit() {
    this.rejectsService.getRejectedAssets(this.jobId);
  }

  ngAfterContentInit() {
    const copyScroller = this.assetListScroll;
    copyScroller.checkViewportSize();
    this.assetListScroll = copyScroller;
  }

  insertUrl(url: any) {
    return `url("${url}")`;
  }

  closeDialog() {
    this.dialogService.closeDialog();
  }

  downloadPDF() {
    if (!!this.loadedRejections) {
      this.downloadingPdf = true;
      this.rejectsService.fetchRejectsPDF(this.loadedRejections, this.jobId)
        .toPromise()
        .then(response => {
          this.downloadingPdf = false;
          this.cd.detectChanges();
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
}
